import React from 'react'
import PropTypes from 'prop-types'
import FilterButtons from './FilterButtons'
import SearchBar from './SearchBar'
import styles from './styles.css'

export default class Mobile extends React.Component {
  static propTypes = {
    markets: PropTypes.array,
    selectedCurrency: PropTypes.object,
    selectCurrency: PropTypes.func,
    searchBarText: PropTypes.string,
    setSearchBarText: PropTypes.func
  }
  render() {
    const {
      markets,
      selectedCurrency,
      selectCurrency,
      searchBarText,
      setSearchBarText
    } = this.props
    return (
      <div className={styles.container}>
        <FilterButtons
          markets={markets}
          selectedCurrency={selectedCurrency}
          selectCurrency={selectCurrency}
        />
        <SearchBar
          searchBarText={searchBarText}
          setSearchBarText={setSearchBarText}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/FilterBar/Mobile/index.js